/**
 * Converts a sentence to title case format.
 *
 * This function takes a string and capitalizes the first letter of each word,
 * while converting the rest of the letters to lowercase. Words are separated by spaces.
 *
 * @param sentence - The input string to convert to title case
 * @returns The title case formatted string, or empty string if input is invalid
 *
 * @example
 * ```typescript
 * toTitleCase('hello world') // Returns: 'Hello World'
 * toTitleCase('UPPERCASE TEXT') // Returns: 'Uppercase Text'
 * toTitleCase('mixed Case Words') // Returns: 'Mixed Case Words'
 * toTitleCase('') // Returns: ''
 * toTitleCase('   ') // Returns: ''
 * ```
 */
export const toTitleCase = (sentence: string) => {
    if (typeof sentence !== 'string' || sentence.trim().length === 0) {
        return ''
    }

    const lowercasedSentence = sentence.toLowerCase()

    const words = lowercasedSentence.split(' ')

    const titleCaseWords = words.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1)
    })

    return titleCaseWords.join(' ')
}
